<template>
  <div>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2>Thank you for registering!</h2>
                  <h4>Your submission is complete.</h4>
                  <!--h5>Genuine Training Mask 3.0</h5-->
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="card card-plain">
                    <div class="content">
                      
                    </div>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="card card-plain">
                    <div class="content">
                      
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2018 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { Card, createToken } from 'vue-stripe-elements-plus'
import { uuid } from 'vue-uuid'
import swal from 'sweetalert2'
import qs from 'qs'
import db from '@/components/firebase/init'
import firebase from 'firebase'
import 'firebase/functions'
import { toolboxMixin } from '@/components/mixins/toolboxMixin'

export default {
  mixins: [toolboxMixin],
  data () {
    return {
      myvariable: 4
    }
  },

  components: { Card },

  methods: {
    async init () {
      // nothing
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      // if (this.$route.params.code) this.code = this.$route.params.code
      // else if (this.$route.query.code) this.code = this.$route.query.code
      // if (!this.code) this.$router.replace('/authenticate')
      this.init()
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/RegisterCodeConfirmation.vue